export default __webpack_public_path__ + "static/media/01.8c418b93.png";